<template lang="pug">
modal( id="oraclesmodal" name="checkfits" :draggable="false" class="checkfits moderns" :width="smallScreen ? '100%' : 600" :height="620" @before-close="beforeClose"  @before-open="beforeOpen" :class="smallScreen ? 'fullscreen' : ''")
  vue-context( ref="fitmenu" )
    li()
      a( href="#" @click.prevent="copyPageData('page', 'text')") Copy page to Clipboard
    li()
      a( href="#" @click.prevent="copyPageData('page', 'html')") Copy page to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageData('page', 'md')") Copy page to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB('page')") Copy page to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="copyPageData('all', 'text')") Copy table to Clipboard
    li
      a( href="#" @click.prevent="copyPageData('all', 'html')") Copy table to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageData('table', 'md')") Copy table to Clipboard (Reddit/MD)
    li()
      a( href="#" @click.prevent="copyPageDataBB('all')") Copy table to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="createImage('checkfits', 'png')") Save screenshot as PNG
    li
      a( href="#" @click.prevent="writeSheet()") Export table to XLS
    li
      a( href="#" @click.prevent="rawData()") Copy raw data
  vue-context( ref="oraclesmenu" )
    li()
      a( href="#" @click.prevent="copyPageData2('page', 'text')") Copy page to Clipboard
    li()
      a( href="#" @click.prevent="copyPageData2('page', 'html')") Copy page to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageDataBB2('page')") Copy page to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="copyPageData2('all', 'text')") Copy table to Clipboard
    li
      a( href="#" @click.prevent="copyPageData2('all', 'html')") Copy table to Clipboard (HTML)
    li()
      a( href="#" @click.prevent="copyPageDataBB2('all')") Copy table to Clipboard (BBCode)
    li
      a( href="#" @click.prevent="writeSheet2()") Export table to XLS
    li
      a( href="#" @click.prevent="rawData2()") Copy raw data
  div#checkfits(style="height:620px;display: inline-block;")
    div.header {{ `CheckFits` + (  samplename ? ` (${samplename.replace(/_/g,' ')})` : '' ) }}
      n-button.closedialog(@click.native="closeModal()")
        i.fas.fa-times
    .row.content()
      .radio
        el-radio-group(v-model="radio" size="mini" fill="#f96332" @change="setpage()")
          el-radio-button(label=0) Modern Averages
          el-radio-button(label=1) Ancient Averages
          el-radio-button(label=3) Shared Samples
      .col-12(v-if="radio == '3' || radio == '0' || radio == '1'" :style="`xheight:${height}px; text-align: center;`" @contextmenu.prevent="$refs.fitmenu.open")
        el-table(:data='pageData' empty-text='No matches found')
          //el-table-column(width='540' label='' class='sample')
            template(slot-scope="{row}" :class="`row-${row.number}`")
              div.custombackground(:style="`background-color: ${row.fill}`" :class="`row-${row.number}`")
              div.customsample(v-tooltip="{offset: '-250, 0', content: row.groups}")
                span.index {{ row.index }}
                span.sample {{row.sample.replace(/_/g,' ').replace(':','   ').length > 58 ? (row.sample.replace(/_/g,' ').replace(':','   ')).substring(0,55) + '...' : row.sample.replace(/_/g,' ').replace(':','   ') }}
                span.distance {{ row.distance ? row.distance.toFixed(2) : 0 }}
          el-table-column(width='60px' label=' ' class='index')
            div.sample(slot-scope="{row}") {{ row.index }}
          el-table-column(width='390' label='' class='sample')
            div.sample(slot-scope="{row}" v-tooltip="{content: row.origin || row.description ? ( ( row.origin ? `Origin: ${row.origin}<br>` : '' ) +  (row.description ? row.description + '<br>' : '') + ( radio == '3' ? `Shared by: <i>${row.alias ? row.alias : row.group}</i><br>` : '')) : radio == '3' ? `Shared by:<i> ${row.group}</i><br>` : '' , classes: [ 'modaltip' ]}") {{row._row.replace(/_/g,' ').replace(':','   ').length > 51 ? (row._row.replace(/_/g,' ').replace(':','   ')).substring(0,48) + '...' : row._row.replace(/_/g,' ').replace(':','   ') }}
          el-table-column(width='85' class='distance') 
            div.distance(style="text-align: center;" slot-scope="{row}") {{ row.distance ? row.distance.toFixed(2) : 0 }}
    //portal-target(:name="'searchinput'")
    .searchcontainer
      .searchcount {{ searchcount }}
      TooltipInput(style="margin:auto;margin-bottom: 10px;width: 100%;" :class="'search'" @sendToParent="onSearchEnter"  v-model="search" :initValue="search"  :suggestions="recentSearches" :placeholder="'Search'" name="alias" @remove-item="onRemoveSuggestion" :editable="true" :clearable="false")
    .pagination(style="text-align: center; position: absolute; bottom: 25px; width: 100%;")
        n-pagination(:page-count="pages" v-model="defaultPagination" style="margin: auto;" v-on:input="log(defaultPagination)")
</template>
<script>
  import domtoimage from 'dom-to-image-improved';
  import getUserProfiles from "@/graphql/getUserProfiles"
  import putUserProfiles from "@/graphql/putUserProfiles"
  import debounce from 'lodash/debounce';
  import TooltipInput from '@/components/TooltipInput.vue';
  import {
      Table,
      TableColumn
  } from 'element-ui'
  import {
      Button,
      Pagination
  } from '@/components'
  import copy from 'copy-html-to-clipboard';
  import table from 'table-builder'
  import tablecss from '../../table.js'
  export default {
      name: 'OraclesModal',
      components: {
          TooltipInput,
          [Table.name]: Table,
          [TableColumn.name]: TableColumn,
          [Button.name]: Button,
          [Pagination.name]: Pagination
      },
      data() {
          return {
              changed: false,
              recentSearches: [],
              showDropdown: false,
              search: '',
              radio: '0',
              samplename: false,
              headers: ['Mixed', '2 Way', '4 Way', 'checkFit'],
              modern: [],
              custom: [],
              tableData: [],
              oracles: [],
              closable: false,
              smallScreen: window.innerWidth < 480 ? true : false,
              defaultPagination: 1,
          }
      },
      computed: {
          searchcount: function() {
          let count = this.tableData && this.tableData.length ? this.tableData.length : 0;
          return `found ${count} matches`
          },
          user: function() {
          return this.$store.getters.get('user');
          },
          pageData: function() {
              let w = this;
              var page = this.defaultPagination;
              var start = page * 10 - 10
              var end = start + 10;
              var pagedata = this.tableData.slice(start, end)
              pagedata.forEach((row, index) => {
                  row.index = start + index + 1;
                  row.number = index;
                  row.fill = w.getColor(row.distance);
              })
              if (this.radio === '0') {
                  return pagedata;
              } else {
                  return pagedata;
              }
          },
          tableDataa: function() {
              let w = this;
              let data = w.radio === '0' ? w.modern : w.radio === '1' ? w.ancient : w.custom
              if (!w.search || w.search.length < 2) return data;
              const terms = w.search.split(/\s+|,|\||\bor\b/gi).map(s => s.trim()).filter(Boolean);
              if (terms.length == 0) return data;
              let debouncedSearch = debounce(w.searchData, 500);
              return debouncedSearch(terms, data) || [];
          },
          pages: function() {
              return this.tableData && this.tableData.length > 0 ? Math.ceil(this.tableData.length / 10) : 0;
          },
          height: function() {
              let rowsize = this.smallScreen ? 47.5 * 0.7 : 47.5;
              return this.pageData.length > 0 ? parseInt((this.pageData.length * rowsize) + 200) : 260;
          }
      },
      watch: {
          search() {
              this.debouncedSearch();
          },
          radio() {
              this.searchData();
          }
      },
      methods: {
        createImage(el, type) {
            let w = this;
            console.log('creating image: ', el);
            w.exporting = true;
            try {
                var filename = el === 'apex-wrapper' ? 'chart' : el;
                var node = document.getElementById(el);
                var style = el === 'table' ? {
                    marginTop: '-50px',
                    padding: 0
                } : el === 'chartresult' ? {
                    'margin-left': 'unset',
                    'width': '100%',
                    marginTop: '-35px',
                    paddingTop: '0px'
                } : el == 'chart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '106.5px',
                    padding: 'unset',
                } : el === 'barchart' ? {
                    'margin': 0,
                    'width': '100%',
                    marginTop: '-10px',
                    padding: 'unset',
                    paddingLeft: '50px',
                    paddingRight: '10px'
                } : {
                    margin: 0,
                    padding: 0
                }
                if (type && type === 'svg') {
                    domtoimage.toSvg(node, {
                            bgcolor: this.theme ? '#14191f' : '#f2f2f2',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            var svgBlob = new Blob([blob], {
                                type: "image/svg+xml;charset=utf-8"
                            });
                            var svgUrl = URL.createObjectURL(svgBlob);
                            img.src = svgUrl
                            console.log(style);
                            window.saveAs(blob, `${filename}.svg`);

                        });
                } else {
                    var style = el === 'table' ? {
                        marginLeft: 0,
                        marginTop: '-50px',
                        padding: 0,
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : el === 'chartresult' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-35px',
                        paddingTop: '0px'
                    } : el === 'chart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '106.5px',
                        padding: 'unset'
                    } : el === 'barchart' ? {
                        'margin-left': 'unset',
                        'width': '100%',
                        marginTop: '-10px',
                        padding: 'unset',
                        paddingLeft: '50px',
                        paddingRight: '10px'
                    } : {
                        marginLeft: 0,
                        padding: 0
                    }
                console.log('style', style);
                    domtoimage.toBlob(node, {
                            bgcolor: this.theme ? '#181818' : 'white',
                            style: style
                        })
                        .then(function(blob) {
                            var img = new Image();
                            img.src = blob
                            window.saveAs(blob, `${filename}.png`);
                            w.exporting = false;
                        }).catch(err => {
                            w.exporting = false;
                        })
                }
            } catch (err) {
                w.exporting = false;
            }

        },
          async saveSearch(data) {
                      try {
                      let user = this.user.username
                      let type = 'savedFitSearches'
                      let result;
                      let updated = await this.$apollo.mutate({
                          mutation: putUserProfiles,
                          variables: {
                              user: user,
                              type: type,
                              data: JSON.stringify(data)
                          }
                      })
                      result = updated.data && updated.data.putUserProfiles && updated.data.putUserProfiles.data ? JSON.parse(updated.data.putUserProfiles.data) : null
                      return result;
                      }
                      catch(err) {
                      console.log('putUserProfiles error', err.message || err)
                      return false
                      }
          },
          async getSearch() {
                      try {
                      let user = this.user.username
                      let type = 'savedFitSearches';
                      let data;
                      let profile = await this.$apollo.query({
                          query: getUserProfiles,
                          variables: {
                              user: user,
                              type: type,
                          },
                      fetchPolicy: 'network-only'
                      })
                      data = profile.data && profile.data.getUserProfiles && profile.data.getUserProfiles.data ? JSON.parse(profile.data.getUserProfiles.data) : null
                      return data
                      }
                      catch(err) {
                      console.log('getUserProfiles error', err.message || err)
                      return false
                      }
          },
        onRemoveSuggestion(item, idx) {
                this.recentSearches.splice(idx, 1);
                this.saveSearch(this.recentSearches);
                },
          searchData: function() {
              let data = this.radio === '0' ? this.modern : this.radio === '1' ? this.ancient : this.custom;
              if (!this.search || this.search.length < 2) {
                  this.tableData = data;
                  return;
              }
              const terms = this.search.split(/\s+|,|\||\bor\b/gi).map(s => s.trim()).filter(Boolean);
              if (terms.length === 0) {
                  this.tableData = data;
                  return;
              }
              this.tableData = data.filter(obj =>
                  terms.some(term =>
                      obj.sample && obj.sample.toLowerCase().includes(term.toLowerCase()) || obj.origin && obj.origin.toLowerCase().includes(term.toLowerCase())
                  )
              );
          },
          debouncedSearch: debounce(function() {
              this.searchData();
          }, 200),
          hideDropdown() {
              setTimeout(() => {
                  this.showDropdown = false;
              }, 150);
          },
          async onSearchEnter(evt) {
              let w = this;
              console.log('term', w.search.length, this.recentSearches);
              if (w.search && w.search.length > 10 && !this.recentSearches.some( x => x.toLowerCase().trim() == w.search.toLowerCase().trim())) {
                  this.recentSearches.unshift(w.search);
                  this.recentSearches = this.recentSearches.slice(0, 10);
                  await w.saveSearch(this.recentSearches);
              }
          },
          async saveRecentSearch(term) {
              if (!this.recentSearches.includes(term) && term.length > 10 && !this.recentSearches.some( x => x.toLowerCase().trim() == term.toLowerCase().trim())) {
                  this.recentSearches.unshift(term);
                  this.recentSearches = this.recentSearches.slice(0, 10);
                  await w.saveSearch(this.recentSearches);
                  //localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
              }
          },
          pickRecent(term) {
              this.search = term;
              this.showDropdown = true;
          },
          clearSearch() {
              this.search = ''
              this.showDropdown = false;
          },
          logit() {},
          setpage() {
              this.defaultPagination = 1;
              console.log('set page');
          },
          getColor: function(value, scatter) {
              if (scatter) {
                  return `rgba(128,128,128,0.5)`;
              }

              function interpolateColor(start, end, ratio) {
                  const r = Math.round(start[0] + (end[0] - start[0]) * ratio);
                  const g = Math.round(start[1] + (end[1] - start[1]) * ratio);
                  const b = Math.round(start[2] + (end[2] - start[2]) * ratio);
                  return [r, g, b];
              }
              let red = 0,
                  green = 0,
                  blue = 0;
              const alpha = 1; // fully opaque
              if (value < 0) {
                  value = 0;
              }

              if (value >= 20) {
                  [red, green, blue] = [0, 0, 0];
              } else if (value >= 10) {
                  const ratio = (value - 10) / (20 - 10);
                  [red, green, blue] = interpolateColor([255, 0, 0], [0, 0, 0], ratio);
              } else if (value >= 5) {
                  const ratio = (value - 5) / (10 - 5);
                  [red, green, blue] = interpolateColor([255, 165, 0], [255, 0, 0], ratio);
              } else if (value >= 3.5) {
                  const ratio = (value - 3.5) / (5 - 3.5);
                  [red, green, blue] = interpolateColor([205, 171, 0], [255, 165, 0], ratio);
              } else if (value >= 2.5) {
                  const ratio = (value - 2.5) / (3.5 - 2.5);
                  [red, green, blue] = interpolateColor([0, 255, 0], [205, 171, 0], ratio);
              } else if (value >= 1.5) {
                  const ratio = (value - 1.5) / (2.5 - 1.5);
                  [red, green, blue] = interpolateColor([0, 150, 0], [0, 255, 0], ratio);
              } else {
                  const ratio = (value - 0) / (1.5 - 0);
                  [red, green, blue] = interpolateColor([0, 100, 0], [0, 150, 0], ratio);
              }

              return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
          },
          beforeOpen: async function(evt) {
              this.showDropdown = true;
              this.radio = '0';
              this.recentSearches = [];
              //const saved = localStorage.getItem('recentSearches');
              const saved = await this.getSearch();
              if (saved) this.recentSearches = saved;
              this.debouncedSave = debounce(this.saveRecentSearch, 500);
              this.search = '';
              this.defaultPagination = 1;
              this.samplename = evt.params.results && evt.params.results.sample ? evt.params.results.sample.sample :
                  false
              let modern = evt.params.results && evt.params.results.nearest ? [...evt.params.results.nearest.filter(
                  x => x.calc == "allModernAverages")] : []
              let custom = evt.params.results && evt.params.results.nearest ? [...evt.params.results.nearest.filter(
                  x => x.calc == "customUsers")] : []
              let ancient = evt.params.results && evt.params.results.nearest ? [...evt.params.results.nearest
                  .filter(x => x.calc == "allAncientAverages")
              ] : []
              if (modern[0] && modern[0].nearest) {
                  modern = modern[0].nearest
                  modern.map(x => x._row = x._row.split(':')[0].split(']').length > 1 ? x._row.split(' [')[1].split(
                          ':')[0].replace(/\]/, '') + '_' + x._row.split(' [')[0] + x._row.split(']')[1] : x
                      ._row)
                  this.modern = modern
              }
              if (custom[0] && custom[0].nearest) {
                  custom = custom[0].nearest;
                  custom.map(x => x._row = x._row.split(':')[0].split(']').length > 1 ? x._row.split(' [')[1].split(
                          ':')[0].replace(/\]/, '') + '_' + x._row.split(' [')[0] + x._row.split(']')[1] : x
                      ._row)
                  this.custom = custom
              }
              if (ancient[0] && ancient[0].nearest) {
                  ancient = ancient[0].nearest
                  ancient.map(x => x._row = x._row.split(':')[0].split(']').length > 1 ? x._row.split(' [')[1]
                      .split(':')[0].replace(/\]/, '') + '_' + x._row.split(' [')[0] + x._row.split(']')[1] : x
                      ._row)
                  this.ancient = ancient
              }
              this.tableData = this.radio === '0' ? this.modern : this.radio === '1' ? this.ancient : this.custom;
          },
          getXLS: () => {
              return new Promise((resolve, reject) => {
                  if (!window.XLSX) {
                      let script = document.createElement('script')
                      script.onload = () => {
                          resolve(true)
                      }
                      script.async = true
                      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.15.2/xlsx.core.min.js'
                      document.head.appendChild(script)
                  } else {
                      resolve(true)
                  }
              })
          },
          writeSheet2() {
              this.$eventBus.$emit('spinner', 'run')
              if (this.tableData) {
                  var data = this.tableData;
                  var rows = [];
                  let header = `${this.headers[this.radio]} Oracles`
                  var columns = [header, 'Distance']
                  rows.push(columns);
                  data.forEach(function(p) {
                      var result = []
                      result.push(p.fullmsg ? p.fullmsg : p.message);
                      result.push(p.distance);
                      rows.push(result)
                  })
                  this.getXLS().then((res) => {
                      var wb = XLSX.utils.book_new();
                      var ws = XLSX.utils.aoa_to_sheet(rows);
                      XLSX.utils.book_append_sheet(wb, ws, "table");
                      XLSX.writeFile(wb, "data.xlsx", {
                          compression: true
                      });
                  }).catch(err => {
                      this.$eventBus.$emit('spinner', 'stop')
                      console.log(err)
                  })
              } else {
                  console.log('Nothing to export..')
              }
              this.$eventBus.$emit('spinner', 'stop')
          },
          rawData2() {
              if (this.tableData) {
                  var data = []
                  this.tableData.forEach((oracle, index) => {
                      var obj = {}
                      let header = `${this.headers[this.radio]} Oracles`.toLowerCase();
                      obj[header] = {
                          ...oracle
                      }.fullmsg ? {
                          ...oracle
                      }.fullmsg : {
                          ...oracle
                      }.message
                      obj.distance = {
                          ...oracle
                      }.distance
                      obj.rank = index + 1;
                      data.push(obj);
                  })
                  let prettyJSON = JSON.stringify(data, null, 2)
                  copy(prettyJSON, {
                      asHtml: false
                  });

              } else {
                  console.log('Nothing to copy..')
              }
          },
          copyPageDataBB2(page) {
              var data = page === 'page' ? this.pageData : this.tableData;
              var headers = {}
              var tabledata = []
              headers.mix = `${this.headers[this.radio]} Oracles`
              headers.distance = 'Distance'
              data.forEach(oracle => {
                  var obj = {};
                  obj.mix = oracle.fullmsg ? oracle.fullmsg : oracle.message;
                  obj.distance = oracle.distance;
                  tabledata.push(obj)
              })
              var copyhtml = new table().setHeaders(headers).setData(tabledata).render()
              copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
              var replace = new RegExp(' class=.*?]', 'g')
              copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, ': ')
              copyhtml = `[size=1]${copyhtml}[/size]`
              copy(copyhtml, {
                  asHtml: false,
              });
          },
          copyPageData2(page, type) {
              var data = page === 'page' ? this.pageData : this.tableData;
              var headers = {}
              var tabledata = []
              headers.mix = `${this.headers[this.radio]} Oracles`
              headers.distance = 'Distance'
              data.forEach(oracle => {
                  var obj = {};
                  obj.mix = oracle.fullmsg ? oracle.fullmsg : oracle.message;
                  obj.distance = oracle.distance;
                  tabledata.push(obj)
              })
              var copyhtml = new table({
                  'class': 'tableHTML'
              }).setHeaders(headers).setData(tabledata).render()
              let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
              if (type === 'text') {
                  copy(copytext, {
                      asHtml: false,
                  });
              } else {
                  copy(copyhtml, {
                      asHtml: true,
                  });
              }
          },
          writeSheet() {
              this.$eventBus.$emit('spinner', 'run')
              if (this.tableData) {
                  var data = this.tableData;
                  var rows = [];
                  var columns = ['sample', 'distance']
                  rows.push(columns);
                  data.forEach(function(p) {
                      var result = []
                      result.push(p._row);
                      result.push(p.distance);
                      rows.push(result)
                  })
                  var wb = XLSX.utils.book_new();
                  var ws = XLSX.utils.aoa_to_sheet(rows);
                  XLSX.utils.book_append_sheet(wb, ws, "table");
                  XLSX.writeFile(wb, "data.xlsx", {
                      compression: true
                  });
              } else {
                  console.log('Nothing to export..')
              }
              this.$eventBus.$emit('spinner', 'stop')
          },
          rawData() {
              if (this.tableData) {
                  var data = []
                  this.tableData.forEach((sample, index) => {
                      var obj = {}
                      obj.sample = {
                          ...sample
                      }.sample ? {
                          ...sample
                      }.sample : {
                          ...sample
                      }._row
                      obj.distance = {
                          ...sample
                      }.distance
                      obj.rank = index + 1;
                      data.push(obj);
                  })
                  let prettyJSON = JSON.stringify(data, null, 2)
                  copy(prettyJSON, {
                      asHtml: false
                  });

              } else {
                  console.log('Nothing to copy..')
              }
          },
          copyPageDataBB(page) {

              var data = page === 'page' ? this.pageData : this.tableData;
              var headers = {}
              var tabledata = []
              headers.sample = 'Sample'
              headers.distance = 'Distance'
              data.forEach(sample => {
                  var obj = {};
                  obj.sample = sample._row.replace(/_/g, ' ');
                  obj.distance = sample.distance;
                  tabledata.push(obj)
              })
              var copyhtml = new table().setHeaders(headers).setData(tabledata).render()
              copyhtml = copyhtml.replace(/</g, '[').replace(/>/g, ']')
              var replace = new RegExp(' class=.*?]', 'g')
              copyhtml = copyhtml.replace(replace, ']').replace(/ ]/g, ']').replace(/:/g, ': ')
              copyhtml = `[size=1]${copyhtml}[/size]`
              copy(copyhtml, {
                  asHtml: false,
              });
          },
          copyPageData(page, type) {
              let w = this;
              var data = page === 'page' ? this.pageData : this.tableData;
              var headers = {}
              var tabledata = []
              headers.sample = 'Sample'
              headers.distance = 'Distance'
              data.forEach(sample => {
                  var obj = {};
                  obj.sample = sample._row
                  obj.distance = sample.distance;
                  tabledata.push(obj)
              })
              var copyhtml = new table({
                  'class': 'tableHTML'
              }).setHeaders(headers).setData(tabledata).render()
              let copytext = this.$yaml.stringify(tabledata, 2).replace(/-\n/g, '\n').replace(/'/g, '')
              if (type && type == 'md') {
                  let table = []
                  let tablehead = Object.keys(headers).map(x => headers[x])
                  table.push(tablehead);
                  tabledata.map(x => {
                      let row = []
                      Object.keys(headers).map(y => {
                          row.push(typeof(x[y]) == 'string' ? x[y].replace('<b>', '').replace(
                              '</b><br/><br/>', '').replace('<br/>', ' ') : x[y])
                      })
                      table.push(row);
                  })
                  let copyhtml = w.$mdtable(table, {
                      align: ['l', 'l', 'l']
                  })
                  console.log(copyhtml);
                  copy(copyhtml, {
                      asHtml: false
                  });
              } else if (type === 'text') {
                  copy(copytext, {
                      asHtml: false,
                  });
              } else {
                  copy(copyhtml, {
                      asHtml: true,
                  });
              }
          },
          show: function(params) {
              var w = this;
              var title = params.title ? params.title : 'Alert!'
              var text = params.text ? params.text : 'Message received...'
              var buttons = [{
                      title: 'Continue',
                      default: false, // Will be triggered by default if 'Enter' pressed.
                      handler: () => {
                          w.closable = true;
                          w.$modal.hide('dialog');
                          w.closeModal(true);
                      }
                  },
                  {
                      title: 'Cancel',
                      default: true,
                      handler: () => {
                          w.closable = false;
                          w.$modal.hide('dialog');
                      } // Button click handler
                  }
              ]
              this.$modal.show('dialog', {
                  title: title,
                  text: text,
                  class: params.class ? params.class : undefined,
                  buttons: buttons
              })
          },
          log: function(params, row) {
              return;
          },
          beforeClose: function(event) {
              this.$eventBus.$emit('appEvents', {
                  exec: 'resetTip',
                  component: 'g25'
              });
          },
          closeModal: function(flag) {
              this.$modal.hide('checkfits')
          }
      },
      created() {}
  }
</script>
<style lang="scss">
  #oraclesmodal .el-table__header-wrapper {
    display: none;
  }

  #oraclesmodal .el-table .shrink {
    font-size: 0.95em;
  }

  #oraclesmodal .radio {
    width: 100%;
    margin-top: 35px;
  }

  #oraclesmodal .radio .el-radio-group {
    width: 100%;
    text-align: center;
  }

  #oraclesmodal .radio .el-radio-button,
  #oraclesmodal .radio .el-radio-button__inner {
    display: inline-block;
    position: relative;
    outline: 0;
    width: 100px;
    margin-left: 1px;
  }

  #oraclesmodal .radio *:focus,
  #oraclesmodal .radio *:focus-within,
  #oraclesmodal .radio *:active {
    outline: 0;
  }

  div.form-check {
    position: absolute;
    top: -7px;
    left: -9px;
    display: inline-block;
    color: black;
    z-index: 999;
  }

  .form-check .form-check-sign::before,
  .form-check .form-check-sign::after {
    font-weight: 700;
    color: black;
    background-color: #6c848db8;
    background-color: white;
    border: 1px solid #837c7c;
    width: 20px;
    height: 20px;
  }

  .v--modal .header {
    position: absolute;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    padding-top: 10px;
    z-index: 2;
    width: 100%;
    height: 40px;
    color: black;
  }

  .form-check .form-check-sign.active::before,
  .form-check .form-check-sign.active::after {
    /*background-color: #00678d;*/
  }

  .form-check .form-check-label {
    font-size: 10px;
    text-transform: uppercase;
    color: white;
    font-weight: 700;
    line-height: 20px;
  }

  div.modalHeader {
    text-align: center;
    font-weight: 300;
    padding-top: 11px;
    position: absolute;
    font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    font-size: 18.2px;
    z-index: 2;
    line-height: 22px;
    margin-bottom: 0;
  }

  .oracles.v--modal-overlay {
    z-index: 2000;
  }

  #app .el-table .cell {
    line-height: 14px;
  }

  #app .oracles .v--modal button.closedialog:hover {
    box-shadow: none;
  }

  #app .oracles .v--modal button.closedialog:active {
    background: #9797971c;
  }

  #app .oracles .v--modal button.closedialog {
    background: transparent;
    color: gray;
    position: absolute;
    top: -11px;
    right: -8px;
  }

  #app .oracles .buttons button.primary {
    width: 90px;
  }

  #app .oracles .el-table {
    padding-top: 0;
  }

  #app #oraclesmodal .el-table .cell {
    cursor: default;
    font-family: helvetica;
    color: #555;
  }

  #app .oracles .el-table__empty-text {
    line-height: 24px;
    font-size: 18px;
    width: 70%;
    margin-left: -42px;
    color: #909399;
  }

  #app .el-table::before {
    height: 0px;
  }

  .oracles {
    border-radius: 5px;
  }

  .oracles.fullscreen .v--modal {
    border-radius: 0px;
  }

  #oraclesmodal.fullscreen .row.content {
    zoom: 70%;
  }

  .oracles .col-12 {
    transition: height 0.3s;
  }

  .oracles .row.content {
    margin-top: 20px;
  }

  .oracles .v--modal {
    transition: top 0.3s;
  }

  #oraclesmodal.moderns .col-12 .el-table {
    padding-top: 10px;
  }

  #oraclesmodal.moderns .radio .el-radio-button,
  #oraclesmodal.moderns .radio .el-radio-button__inner {
    width: 140px;
  }

  #oraclesmodal.moderns .radio {
    margin-top: 50px;
  }

  #oraclesmodal .v--modal button i.fas.fa-times {
    color: gray;
  }

  #oraclesmodal.checkfits.disabled .customsample .index {
    width: 40px;
    display: inline-block;
    height: 24px;
    color: white !important;
  }

  #oraclesmodal.checkfits.disabled .customsample .distance {
    width: 50px;
    float: right;
    display: inline-block;
    color: white !important;
  }

  #oraclesmodal.checkfits.disabled .customsample .sample {
    display: inline-block;
    color: white !important;
  }

  #oraclesmodal.checkfits.disabled .customsample {
    background: inherit;
    position: absolute;
    height: 100%;
    width: 540px;
    top: 0;
    left: 0;
    padding: 12px 20px 10px 20px;
    font-weight: 700;
  }

  #oraclesmodal.checkfits.disabled .el-table table>tbody>tr>td {
    padding: 18px 0px;
  }

  #oraclesmodal.checkfits.disabled .el-tabs--border-card .custombackground.row-0,
  #oraclesmodal.checkfits.disabled .el-table__row.row-index-0 td {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #oraclesmodal.checkfits.disabled .el-tabs--border-card .custombackground.row-19,
  #oraclesmodal.checkfits.disabled .el-table__row.row-index-19 td {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  #oraclesmodal.checkfits.disabled .custombackground {
    background: inherit;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    filter: brightness(0.8) grayscale(0) contrast(1);
    padding: 10px;
  }

  #oraclesmodal.checkfits.disabled .el-table td,
  #oraclesmodal.checkfits.disabled .el-table th.is-leaf {
    border-bottom: 0px;
  }

  #oraclesmodal.checkfits.disabled .custombackground.row-0,
  #oraclesmodal.checkfits.disabled .el-table__row.row-index-0 td {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #oraclesmodal.checkfits.disabled .custombackground.row-19,
  #oraclesmodal.checkfits.disabled .el-table__row.row-index-9 td {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  #oraclesmodal.checkfits.disabled .el-table__body-wrapper {
    width: 540px;
  }

  #oraclesmodal.checkfits.disabled .custombackground {
    background: inherit;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    filter: brightness(0.6) grayscale(0) contrast(1);
    padding: 10px;
  }

  body.dark #oraclesmodal.checkfits.disabled *:not(table *) {
    background: #141414;
    color: white;
  }

  body.dark #oraclesmodal.checkfits.disabled .el-table__row {
    background: #141414;
    color: white;
  }

  body.dark #oraclesmodal.checkfits.disabled .v--modal-box.v--modal {
    border: 1px solid #88888899
  }

  #app #oraclesmodal.checkfits div.searchcontainer {
		display: flex;
    position: absolute;
    bottom: 60px;
    width: 100%;
    margin: auto;
    text-align: center;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    align-items: center;
  }
  #app #oraclesmodal.checkfits div.search {
    width: 350px !important;
    height: 35px;
  }
  #app #oraclesmodal.checkfits div.searchcontainer .searchcount {
		opacity: 0.7;
		font-size: 0.9em;
		font-style: italic;
		height: 25px;
}

  #app #oraclesmodal.checkfits .search input {
    width: 350px !important;
    height: 35px;
    padding: 0.3125em 0.625em;
    padding-right: 30px;
    border-radius: 5px;
    border-style: solid;
    font-weight: 700;
    font-size: 1.1em;
    border-color: #00000021;
    background-color: white;
    color: rgba(0, 0, 0, 0.5);
    margin: auto;
  }

  #app #oraclesmodal.checkfits .search .custom-tooltip {
    left: 50%;
    margin-left: -170px;
    text-align: left;
  }

  #app #oraclesmodal.checkfits .search input:active,
  #app #oraclesmodal.checkfits .search input:focus {
    outline: none;
    border-color: #2362a782;
    box-shadow: none !important;
    text-shadow: none !important;
    background-color: white;
  }

  #app #oraclesmodal.checkfits .search i.fa-search {
    opacity: 0.3;
    cursor: default;
    position: relative;
    left: -25px;
  }
</style>
